import { Typography } from "@mui/material";
import React from "react";
import "./ScreenLoader.css";

function ScreenLoader() {
  return (
    <div align="center" className="loader_section">
      <div>
        <Typography variant="h4" sx={{ color: "white", marginBottom: "100px" }}>
          {" "}
          Welcome to my Portfolio : )
        </Typography>
        <Typography variant="h4" sx={{ color: "white", marginBottom: "100px" }}>
          Loading...
        </Typography>
        <div className="loader">
          <span>&#123; </span>...<span> &#125;</span>
        </div>
      </div>
    </div>
  );
}

export default ScreenLoader;
